@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.tier {
    display: flex;
    margin: 0;
    padding: 0;

    &[hidden] {
        display: none;
    }
}

.toggleIcon {
    width: 1.5em;
    height: 1.5em;
    fill: var(--color-white);
}

.tierOne {
    composes: tier;
    background-color: var(--color-crimson);

    @include breakpoint.breakpoint(layout.$belowMedium) {
        flex-direction: column;
    }
}

.tierTwo {
    composes: tier;
    background-color: var(--color-cardinal);

    @include breakpoint.breakpoint(layout.$belowMedium) {
        flex-direction: column;
        background-color: var(--color-white);
    }
}

.listItem {
    list-style: none;
    flex-grow: 1;

    @include breakpoint.breakpoint(layout.$aboveMedium) {
        flex-basis: 0;
    }

    &:focus {
        background-color: var(--color-black);
    }
}

.link {
    color: var(--color-white);
    display: block;
    height: 100%;
    padding: 1.25rem 0.75rem;
    text-align: center;
    text-decoration: none;
    text-transform: uppercase;
    width: 100%;
}

.accordionToggle {
    composes: link;
    margin: 0;
    background-color: var(--color-crimson);
    cursor: pointer;
    position: relative;
    border: none;
    font-size: 1em;

    svg {
        width: 1.5em;
        height: 1.5em;
        fill: var(--color-white);
        position: absolute;
        right: 1em;
    }
}

.tierOneLink {
    composes: link;
    background-color: var(--color-crimson);

    &.current {
        background-color: var(--color-cardinal);
    }

    @include breakpoint.breakpoint(layout.$aboveMedium) {
        &.current {
            font-weight: 700;
        }
    }

    &:hover {
        background-color: var(--color-cardinal);
    }
}

.tierTwoLink {
    composes: link;
    background-color: var(--color-cardinal);

    &:hover {
        text-decoration: underline;
    }

    @include breakpoint.breakpoint(layout.$aboveMedium) {
        &.current {
            font-weight: 700;
        }
    }

    @include breakpoint.breakpoint(layout.$belowMedium) {
        background-color: var(--color-white);
        color: var(--color-cardinal);
        text-transform: none;

        &.current {
            color: var(--color-black);
        }
    }
}
